import React from "react";
import { motion } from "framer-motion";

export default function Leadership() {
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const leaders = [
    {
      name: "Mr. Siva Sankara Reddy",
      title: "Chairman & Managing Director",
      quote: "Discipline in action, vision in progress.",
      description: `A former Army professional, Siva Sankara Reddy brings discipline, dedication, and vision to MAC LABS LIMITED. With over 20 years of experience in sourcing and supply of formulations, APIs, and bulk drugs, he founded the company to raise standards in safety, quality, and customer trust.

Under his leadership, MAC LABS has grown globally and earned a reputation as a reliable industry partner. He drives ethical marketing, represents the company at major trade shows, and manages key alliances with leading API manufacturers, ensuring strong procurement and growth.

His commitment to excellence keeps MAC LABS ahead in a competitive market.`,
    },
    {
      name: "Mrs. S. Laxmi Sankar",
      title: "Director",
      quote: "Empowering Progress. Transforming Possibilities.",
      description: `Mrs. S. Laxmi Sankar is a visionary leader with expertise in financial re-engineering and business administration. She drives the company’s growth by blending strategic insight with hands-on leadership, strengthening both finance and sales functions.

Known as the firm’s troubleshooter, she turns challenges into opportunities, guiding teams toward innovative, sustainable solutions. Her commitment to excellence and collaboration inspires progress and fuels success across the organization.`,
    },
    {
      name: "Mrs. Divya Shankar",
      title: "Director",
      quote: "Passion with purpose, progress with precision.",
      description: `Divya Shankar, M.Pharm from Osmania University, is a vital force behind MAC LABS LIMITED’s growth and innovation. With a strong passion for pharmaceuticals and a keen strategic vision, she expertly oversees the company’s technical operations, including both API and formulation development.

As a certified professional trained by reputed organizations, Divya drives continuous innovation and quality improvements, helping the company maintain its reputation for excellence and reliability. Her dedication and expertise ensure that MAC LABS is well-positioned for a future of sustained progress and breakthrough achievements.`,
    },
  ];

  return (
    <div>
      {/* ✅ Hero Banner */}
      <div
        className="relative h-[300px] md:h-[400px] w-full bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage: "url('/images/leadership.webp')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
        <h1 className="relative text-4xl md:text-5xl font-bold text-white text-center">
          Our Leadership
        </h1>
      </div>

      <motion.section
        id="leadership"
        className="max-w-5xl mx-auto px-6 py-12"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={container}
      >
        <motion.h1
          className="text-3xl font-bold text-gray-900 mb-10 text-center"
          variants={fadeInUp}
        >
        </motion.h1>

        <motion.div className="space-y-8" variants={fadeInUp}>
          {leaders.map((leader, index) => (
            <motion.div
              key={index}
              className="p-6 border rounded-lg shadow-sm hover:shadow-xl transition duration-300 bg-white"
              variants={fadeInUp}
            >
              <h2 className="text-xl font-semibold text-gray-800">
                {leader.name}
              </h2>
              <h3 className="text-gray-600 mb-2">{leader.title}</h3>
              <p className="italic text-gray-500 mb-4">"{leader.quote}"</p>
              <p className="text-gray-700 whitespace-pre-line">
                {leader.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </motion.section>
    </div>
  );
}
